<template>
  <b-modal
    id="auto-sms-modal"
    :cancel-title="$t('generals.cancel')"
    :ok-title="isEdit ? $t('generals.edit') : $t('generals.create')"
    :title="isEdit ? $t('generals.editing') : $t('generals.creating')"
    no-close-on-backdrop
    size="xl"
    @ok="saveClick"
  >
    <validation-observer ref="autoSmsValidations">
      <b-row>
        <b-col md="6">
          <b-form-group :label="$t('generals.name')+':'">
            <validation-provider
              #default="{ errors }"
              :name="$t('generals.name')"
              rules="required"
            >
              <b-form-input
                v-model="auto_sms.title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :label="$t('sms.sms_template')+':'">
            <validation-provider
              #default="{ errors }"
              :name="$t('sms.sms_template')"
              rules="required"
            >
              <v-select
                v-model="auto_sms.template"
                :options="GET_MAIL_TEMPLATES"
                class="bg-white"
                :reduce="template => template.id"
                label="title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <h3>
            {{ $t('sms.client_parameters') }}
          </h3>
        </b-col>
        <!-- <b-col md="3">
          <b-form-group label="Дата создания с:">
            <flat-pickr
              v-model="whom.start_date"
              class="form-control bg-white"
              style="max-width: 250px;"
              :config="configdateTimePicker"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Дата создания по:">
            <flat-pickr
              v-model="whom.end_date"
              class="form-control bg-white"
              style="max-width: 250px;"
              :config="configdateTimePicker"
            />
          </b-form-group>
        </b-col> -->
        <b-col cols="12">
          <b-form-group>
            <b-form-checkbox v-model="auto_sms.all">
              {{ $t('sms.to_all') }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group :label="$t('sms.gender')+':'">
            <v-select
              v-model="auto_sms.whom.gender"
              :options="genderOptions"
              class="bg-white"
              :disabled="auto_sms.all"
              :reduce="gender => gender.id"
              :get-option-label="option => option.title[$i18n.locale]"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group :label="$t('sms.type_of_ownership')+':'">
            <v-select
              v-model="auto_sms.whom.entity"
              :options="entityOptions"
              :disabled="auto_sms.all"
              class="bg-white"
              :reduce="entity => entity.id"
              label="title"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <h3>
            {{ $t('sms.when_to_send') }}
          </h3>
        </b-col>
        <b-col md="12">
          <b-form-group
            v-slot="{ ariaDescribedby }"
            :label="$t('sms.frequency')"
          >
            <b-form-radio-group
              id="radio-group-1"
              v-model="auto_sms.type_sending"
              :options="period_options"
              :aria-describedby="ariaDescribedby"
              name="radio-options"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="auto_sms.type_sending === 'annual'"
          md="2"
        >
          <b-form-group :label="`${$t('sms.date')}:`">
            <validation-provider
              #default="{ errors }"
              :name="$t('sms.date')"
              rules="required"
            >
              <b-form-input
                v-model="selected_day"
                type="number"
                :max="daysInMonth(selected_month)"
                :min="0"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          v-if="auto_sms.type_sending === 'annual'"
          md="4"
        >
          <b-form-group :label="$t('sms.month')">
            <validation-provider
              #default="{ errors }"
              :name="$t('sms.month')"
              rules="required"
            >
              <v-select
                v-model="selected_month"
                :options="months"
                class="bg-white"
                :reduce="month => month.id"
                :get-option-label="option => option.title[$i18n.locale]"
                @input="changeMonth"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          v-if="auto_sms.type_sending === 'monthly'"
          md="2"
        >
          <b-form-group :label="$t('sms.which_day_month') + ':'">
            <validation-provider>
              <b-form-input
                v-model="selected_day"
                type="number"
                :max="31"
                :min="0"
                @keyup="validateInput"
              />
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BFormRadioGroup,
} from 'bootstrap-vue'
import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
import { required } from '@validations'
import { mapActions, mapGetters, mapState } from 'vuex'
import VSelect from 'vue-select'
// import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from 'flatpickr/dist/l10n/ru'

export default {
  components: {
    BModal,
    ValidationObserver,
    ValidationProvider,
    BRow,
    BFormGroup,
    BCol,
    VSelect,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    // flatPickr,
  },
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    defObj: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      required,
      all_clients: false,
      auto_sms: {
        whom: {
        },
        type_sending: 'annual',
      },
      configdateTimePicker: {
        altInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'Y-m-d',
        locale: Russian,
      },
      whom: {
      },
      selected_month: null,
      selected_day: 1,
      entityOptions: [
        {
          title: this.$t('sms.legal_entity'),
          id: 'yuridiskiy',
        },
        {
          title: this.$t('sms.natural_person'),
          id: 'fizichiskiy',
        },
      ],
      genderOptions: [
        {
          title: {
            uz: 'Erkak',
            ru: 'Мужской',
            en: 'Male',
          },
          id: 'man',
        },
        {
          title: {
            uz: 'Ayol',
            ru: 'Женский',
            en: 'Female',
          },
          id: 'woman',
        },
      ],
      selected_period: 'annual',
      period_options: [
        { text: this.$t('sms.annual'), value: 'annual' },
        { text: this.$t('sms.once_quarterly'), value: 'quarter' },
        { text: this.$t('sms.once_monthly'), value: 'monthly' },
      ],
    }
  },
  computed: {
    ...mapGetters('sms', ['GET_MAIL_TEMPLATES']),
    ...mapState('knowledgeBase', ['months']),
  },
  watch: {
    defObj() {
      this.auto_sms = this.defObj
      if (this.defObj.type_sending === 'annual') {
        const [day, month] = this.defObj.when.split('-')
        this.selected_day = day
        this.selected_month = Number(month)
      } else if (this.defObj.type_sending === 'monthly') {
        this.selected_day = this.defObj.when
      }
    },
  },
  mounted() {
    this.FETCH_MAIL_TEMPLATES()
    console.log(this.months)
  },
  methods: {
    ...mapActions('sms', ['FETCH_MAIL_TEMPLATES', 'ADD_AUTO_SMS', 'EDIT_AUTO_SMS']),
    daysInMonth(month) {
      return new Date('2012', month, 0).getDate()
    },
    changeMonth() {
      if (this.selected_day > this.daysInMonth(this.selected_month)) {
        this.selected_day = this.daysInMonth(this.selected_month)
      }
    },
    saveClick(bvModal) {
      bvModal.preventDefault()
      this.$refs.autoSmsValidations.validate().then(success => {
        if (success) {
          if (this.auto_sms.type_sending === 'annual') {
            this.auto_sms.when = `${this.selected_day}-${this.selected_month}`
          } else if (this.auto_sms.type_sending === 'monthly') {
            this.auto_sms.when = this.selected_day
          } else {
            this.$delete(this.auto_sms, 'when')
          }
          if (this.isEdit) {
            this.EDIT_AUTO_SMS(this.auto_sms).then(() => {
              this.$_successToast(this.$t('generals.changed'))
              this.$emit('success')
            }).catch(() => {
              this.$errorToast(this.$t('generals.error'))
            })
          } else {
            this.ADD_AUTO_SMS(this.auto_sms).then(() => {
              this.$_successToast(this.$t('generals.added'))
              this.$emit('success')
            }).catch(() => {
              this.$errorToast(this.$t('generals.error'))
            })
          }
        }
      })
    },
    validateInput() {
      if (this.selected_day && this.selected_day > 31) {
        this.selected_day = 31
      }
    },
  },
}
</script>

<style>

</style>
